<div class="u-pt30" [ngClass]="{'u-lock': !enabled}">
  <div class="row" *ngIf="showTitle">
    <div class="col-md-12 u-mb30">
      <h2 class="txt txt--section">
        {{numberSection}}. Información sobre aprobación
      </h2>
    </div>
  </div>
  <div class="row" >
    <div class="col-md-4 order-md-1 order-1">
      <div class="form form--required u-mb20">
        <label for="" class="label label-license" style="margin-bottom: 0px !important;">
          Contract Owner
          <h6 class="txt txt--paragraph" style="position: absolute;">
            Selecciona al Contract Owner que apruebe la solicitud.
          </h6>
        </label>
        <app-select-list
          #SuperintendentComponent
          hintText="*El rut debe ser sin puntos y con guión"
          [optional]="true"
          (textInputValueEmitter)="onInputChange($event)"
          [optionList]="list"
          placeHolder="Buscar por nombre, rut* o email"
          (selectedValueEmitter)="onSelectPerson($event)"
          [isLoading]="isLoading"
        >
        </app-select-list>
      </div>
    </div>
  </div>
</div>
